<template>
  <el-dialog width="1150px" :visible="isShow" :close-on-click-modal="false" :modal-append-to-body="false" :append-to-body="true" :show-close="false">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 半成品入库表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="dialog-main-container" style="height:600px">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="入库日期" required>
                 <span>{{formData.date}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="入库单号">
                <span>{{formData.halfproduct_no}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <span>{{formData.remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="detail-header">
            <div class="detail-title"><i class="em-icon-th-list"></i> 半成品入库明细</div>
        </div>
        <div class="el-table-container form-details" style="top: 66px;">
          <div style="height: 100%;">
            <el-table :data="formData.details" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row">
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="样本册名称" prop="product_name" width="100" align="center"></el-table-column>
              <el-table-column label="台数" prop="table_number" width="80" align="center"></el-table-column>
              <el-table-column label="页码" prop="page" width="80" align="center"></el-table-column>
              <el-table-column label="送货数量" prop="delivery_number" width="80" align="center"></el-table-column>
              <el-table-column label="入库数量" prop="number" width="80" align="center"></el-table-column>
              <el-table-column label="库位" prop="position_value" width="140" align="center"></el-table-column>
              <el-table-column label="异常原因" prop="exception_result" width="200" align="center"></el-table-column>
              <el-table-column label="备注" prop="remark" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-footer">
          <span>制单人：{{formData.creater_name}}</span>
          <span>制单日期：{{formData.create_time.substring(0,10)}}</span>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      formEmptyData: {
        id: '0',
        date: '',
        halfproduct_no: '',
        remark: '',
        details: [],
        creater_name: sessionStorage.getItem('operator'),
        creater_id: sessionStorage.getItem('operator_id'),
        create_time: ''
      },
      formDetailEmptyData: {
        id: '',
        halfproduct_id: '',
        delivery_id: '',
        delivery_detail_id: '',
        product_id: '',
        product_name: '',
        table_number: '',
        page: '',
        number: '0',
        position: '',
        position_value: '',
        remark: ''
      },
      operator_id: sessionStorage.getItem('operator_id'),
      editable: this.$store.state.editable,
      delable: this.$store.state.delable
    }
  },
  beforeCreate: function () {
    var date = new Date()
    var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getHalfProsuctInstoreForm, { HalfProductInstoreId: _this.formData.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          _this.positionArr = _json.position
          if (_json.formData != null) {
            _this.formData = _json.formData
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
            _this.formData.creater_id = _this.operator_id
            _this.formData.date = _this.currentDate
            _this.$nextTick(function () {
              _this.$refs.input.focus()
            })
          }
        }
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
    }
  },
  components: {
  }
}
</script>
